import axiosInstance from '../Utilities/authToken'
import types from '../Stores/types'

export const getChannels = token => {
	return dispatch => {
		axiosInstance
			.get('channels', {
				headers: {
					authorization: `Bearer ${token}`,
				},
			})
			.then(({ data }) => {
				if (!data.error) {
					dispatch({ type: types.SET_CHANNELS, payload: data.data })
				}
			})
			.catch(err => {
				console.log(err)
			})
	}
}

export const setCurrentChannel = channelId => {
	try {
		localStorage.setItem('channel_id', channelId)
	} catch (e) {}
	return {
		type: types.SET_CURRENT_CHANNEL,
		payload: channelId,
	}
}
